import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import TankerFill from "../Modules/Oilmanagement/operation/TankerFill/TankerFill";
import TruckFill from "../Modules/Oilmanagement/operation/TruckFill/TruckFill";
import "./OilScan.css";

const useQuery = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

export default function OilScan() {
  const { mode } = useParams();
  const query = useQuery();
  const tankerId = query.get("tankerId") || "";
  const truckId = query.get("truckId") || "";
  const scanMode = mode === "pump" ? "pump" : "tanker";

  return (
    <main className="oil-scan-page">
      <section className="oil-scan-header">
        <div>
          <p>QR Oil Entry</p>
          <h1>{scanMode === "pump" ? "Fill Tanker From Pump" : "Fill Vehicle From Tanker"}</h1>
        </div>
        <Link to="/oil">Back to Oil</Link>
      </section>

      <section className="oil-scan-card">
        {scanMode === "pump" ? (
          <TruckFill initialTankerId={tankerId} qrEntryMode />
        ) : (
          <TankerFill initialTankerId={tankerId} initialTruckId={truckId} qrEntryMode />
        )}
      </section>
    </main>
  );
}
